import { required, withMessage } from '@certemy/common';

import { IPermissions, IPolicies } from 'services/policy-permission/policy-permissions.service';

export const REQUIRED_MESSAGE = 'Please provide information in all required fields.';
export const REQUIRED_LEGAL_NAME_MESSAGE = 'While providing a Legal Name is optional, if you do so, you must provide a Legal First Name and Legal Last Name. If not, please leave both fields blank.';

export const requiredWithMessage = withMessage(REQUIRED_MESSAGE, required);
export const requiredDependentLegalName = withMessage(REQUIRED_LEGAL_NAME_MESSAGE, required);

export type PROFILE_CARD_POLICIES_KEYS =
  | 'internalIdEdit'
  | 'personalInfoEdit'
  | 'titlesFeatureFlag'
  | 'locationsFeatureFlag'
  | 'editOwnProfile'
  | 'organizationRolesFeatureFlag'
  | 'managersFeatureFlag';

export const PROFILE_CARD_POLICIES: IPolicies<PROFILE_CARD_POLICIES_KEYS> = {
  internalIdEdit: { name: 'internalIdEdit', url: 'settings/users/internal_id', action: 'edit' },
  personalInfoEdit: { name: 'personalInfoEdit', url: 'settings/users/personal_information', action: 'edit' },
  titlesFeatureFlag: { name: 'titlesFeatureFlag', url: 'global/feature_flag/titles', action: 'enable' },
  locationsFeatureFlag: { name: 'locationsFeatureFlag', url: 'global/feature_flag/locations', action: 'enable' },
  editOwnProfile: { name: 'editOwnProfile', url: 'settings/users/own_profile', action: 'edit' },
  organizationRolesFeatureFlag: {
    name: 'organizationRolesFeatureFlag',
    url: 'global/feature_flag/organization_roles',
    action: 'enable',
  },
  managersFeatureFlag: {
    name: 'managersFeatureFlag',
    url: 'global/feature_flag/managers',
    action: 'enable',
  },
};

export const DEFAULT_PROFILE_CARD_PERMISSIONS: IPermissions<PROFILE_CARD_POLICIES_KEYS> = {
  internalIdEdit: false,
  personalInfoEdit: false,
  titlesFeatureFlag: false,
  locationsFeatureFlag: false,
  editOwnProfile: false,
  organizationRolesFeatureFlag: false,
  managersFeatureFlag: false,
};

export interface IManagers {
  profileId: number;
  internalId: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface IImageConfig {
  imageFile: string;
  originalImageFile: string;
  imageConfiguration: {
    left: number;
    top: number;
    width: number;
    height: number;
    naturalHeight: number;
    naturalWidth: number;
  };
}
